import type { LeadStatusFilter } from 'app/features/leads/services/gym-finder/types';

export type LeadsPageState = 'zero-leads-profile-incomplete' | 'first-lead' | 'filtered-empty' | 'table';

type GetLeadsPageStateParams = {
  totalCount: number;
  filteredCount: number;
  profileComplete: boolean;
  search: string;
  status: LeadStatusFilter;
  isFirstPage: boolean;
};

const hasActiveFilters = (search: string, status: LeadStatusFilter) => search.trim().length > 0 || status !== 'all';

export const getLeadsPageState = ({
  totalCount,
  filteredCount,
  profileComplete,
  search,
  status,
  isFirstPage,
}: GetLeadsPageStateParams): LeadsPageState => {
  if (isFirstPage && totalCount === 0 && !profileComplete) {
    return 'zero-leads-profile-incomplete';
  }

  if (hasActiveFilters(search, status) && filteredCount === 0) {
    return 'filtered-empty';
  }

  if (isFirstPage && totalCount === 1 && filteredCount === 1 && !hasActiveFilters(search, status)) {
    return 'first-lead';
  }

  return 'table';
};
